import { formattedDate } from '@/Utils/Utils';

export const COLUMNS = [
	{
		title: 'Module Name',
		dataIndex: 'name',
		width: '30%',
	},
	{
		title: 'Module Short Name',
		dataIndex: 'shortName'
	},
	{
		title: 'Remark',
		dataIndex: 'remark'
	},
	{
		title: 'Create Time',
		dataIndex: 'createTime',
		render: (text: string) => text ? formattedDate(text) : '-'
	},
	{
		title: 'Last Updated',
		dataIndex: 'updateTime',
		render: (text: string) => text ? formattedDate(text) : '-'
	},
];


export const DEFAULT_PAGE_SIZE =  10
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100]
